import { MODAL_TYPES, ModalType } from 'components/PageLayout/Modals/types';


export const getModalTranslationKey = (modalType: ModalType): string | undefined => {
  const modalTypes = Object.values(MODAL_TYPES);
  const matchingModal = modalTypes.find((modal) => modal.value === modalType.value);

  return matchingModal ? matchingModal.key : undefined;
}
